declare namespace $ {

	type __shm_hitalama_components_preview_1 = $mol_type_enforce<
		Parameters< $shm_hitalama_components_preview['mocked'] >[0]
		,
		Parameters< ReturnType< $shm_hitalama_components_preview['demo_model'] >['mocked'] >[0]
	>
	type $mol_check_box__title_shm_hitalama_components_preview_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_hitalama_components_preview_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_preview['mocked'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_link_iconed__hint_shm_hitalama_components_preview_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link_iconed['hint'] >
	>
	type $mol_link_iconed__arg_shm_hitalama_components_preview_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_preview['fullscreen_arg'] >
		,
		ReturnType< $mol_link_iconed['arg'] >
	>
	type $mol_link_iconed__sub_shm_hitalama_components_preview_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link_iconed['sub'] >
	>
	type $mol_view__sub_shm_hitalama_components_preview_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_preview['content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_hitalama_components_preview_description__definition_shm_hitalama_components_preview_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_preview['definition'] >
		,
		ReturnType< $shm_hitalama_components_preview_description['definition'] >
	>
	type $shm_hitalama_components_demo__definition_shm_hitalama_components_preview_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_preview['definition'] >
		,
		ReturnType< $shm_hitalama_components_demo['definition'] >
	>
	export class $shm_hitalama_components_preview extends $mol_page {
		mocked( next?: ReturnType< ReturnType< $shm_hitalama_components_preview['demo_model'] >['mocked'] > ): ReturnType< ReturnType< $shm_hitalama_components_preview['demo_model'] >['mocked'] >
		Demo_mocked( ): $mol_check_box
		fullscreen_arg( ): Record<string, any>
		Fullscreen_icon( ): $mol_icon_arrow_expand_all
		Fullscreen( ): $mol_link_iconed
		content( ): readonly($mol_view)[]
		Result( ): $mol_view
		Description( ): $shm_hitalama_components_preview_description
		definition( ): $shm_hitalama_map_widget_entity_custom
		demo_model( ): $shm_hitalama_components_demo
		title( ): string
		minimal_width( ): number
		tools( ): readonly(any)[]
		body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=preview.view.tree.d.ts.map